import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const textParallax = document.querySelectorAll(".parallax-text");

textParallax.forEach((text) => {
    ScrollTrigger.matchMedia({
        "(max-width: 766px)": function () {
            gsap.set(text, {
                clearProps: "all"
            })
        },
        "(min-width: 766px)": function () {
            gsap.fromTo(text, {
                x: "0%"
            }, {
                x: "-15%",
                scrollTrigger: {
                    trigger: text,
                    start: "top bottom",
                    end: "bottom top",
                    scrub: 1,
                }
            });

            ScrollTrigger.addEventListener("refreshInit", () => {
                gsap.set(text, {
                    clearProps: "x"
                })
            });
        }
    });
});